import { mapEnumToOptions } from '@abp/ng.core';

export enum ProjectCreditNoteStatus {
  InProgress = 0,
  Approved = 1,
}

export const projectCreditNoteStatusOptions = mapEnumToOptions(ProjectCreditNoteStatus);
